import { AsyncPipe } from "@angular/common";
import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map, Observable, switchMap } from "rxjs";
import { ExternArbetsorderDetailsViol2Component } from "./extern-arbetsorder-search/extern-arbetsorder-details/viol2/extern-arbetsorder-details-viol2.component";
import { ExternArbetsorderDetailsViol3Component } from "./extern-arbetsorder-search/extern-arbetsorder-details/viol3/extern-arbetsorder-details-viol3.component";
import { ExternArbetsorderDetailsViewModel } from "./models/ExternArbetsorderDetailsViewModel";
import { ExternArbetsorderService } from "./services/externArbetsorder.service";

@Component({
    selector: "rask-extern-arbetsorder",
    imports: [
        ExternArbetsorderDetailsViol3Component,
        ExternArbetsorderDetailsViol2Component,
        AsyncPipe
    ],
    templateUrl: "./extern-arbetsorder.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./extern-arbetsorder.component.scss"
})
export class ExternArbetsorderComponent implements OnInit {
    protected externArbetsorderDetails$: Observable<ExternArbetsorderDetailsViewModel>;

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly externArbetsorderService = inject(ExternArbetsorderService);

    ngOnInit(): void {
        this.externArbetsorderDetails$ = this.activatedRoute.params.pipe(
            map(params => +params.id),
            switchMap(arbetsorderId => this.externArbetsorderService.getExternarbetsorderDetails(arbetsorderId)),
            map(externarbetsorder => new ExternArbetsorderDetailsViewModel(externarbetsorder))
        );
    }

}
